import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageTitleItem from "./common/ImageTitleItem"
import ImageSectionItem from "./common/ImageSectionItem"
import SeparatorLine from "./common/SeparatorLine"
import IconPanel from "./common/IconPanel"
import BluePanelSection from "./common/BluePanelSection"
import "./Us.css"
import { useEffect } from "react"
import TextItem from "./common/TextItem"

const Us = () => {

    useEffect(() => {
        document.title = 'Séneca - Nosotros'
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="administration-main">

            <ImageTitleItem
                imageURL="/images/us/nosotros-1.jpg"
                titleText="Séneca es un referente en la gestión de contenidos audiovisuales"
                icon="bi bi-diagram-3-fill blue-icon"
                subtitleText="Gracias al trabajo en colaboración con varios parlamentos autonómicos españoles y un profundo análisis del proceso de grabación y transcripción de debates parlamentarios y plenos municipales, desde el año 2000 Séneca se convierte en una referencia, ofreciendo servicios audiovisuales a instituciones y empresas">
            </ImageTitleItem>
            <SliderImageSeparator />

            <ImageSectionItem
                imageURL="/images/us/spica.png"
                imagePosition="before"
                layout="column"
                title="60 años innovando"
                textArray={[
                    "<p class='middle-section-label'><strong>Somos una empresa que ha confiado en el progreso tecnológico desde su fundación y que ha sabido superar con éxito, a través de más de 60 apasionantes años, los retos que el futuro le ha planteado.</strong></p>",
                    "<p class='middle-section-label'>Sus orígenes, a finales de la década de los 50, parten del deseo de acercar a España el mundo de la imagen y el sonido que estaban naciendo en otros países como EE.UU. y Japón. En la actualidad Spica es una empresa dinámica e innovadora gracias a su amplio conocimiento técnico y a las fuertes dosis de imaginación que sabe aplicar en cada proyecto.</p>",
                    "<p class='middle-section-label'>Prueba de ello es el respaldo de más de 5.000 clientes, profesionales de diversos campos: empresas de producción audiovisual, televisiones locales, departamentos de imagen de bancos, escuelas de imagen, hospitales... y otras importantes instituciones públicas como Parlamentos Autonómicos, Diputaciones y Ayuntamientos.</p>"
                ]}
            />
            <SeparatorLine />

            <ImageSectionItem
                imageURL="/images/us/nosotros-2.jpg"
                imagePosition="before"
                layout="column"
                title="Equipo"
                textArray={[
                    "<p class='middle-section-label'>Un ejemplo de nuestra metodología es la <strong>apuesta por la investigación.</strong> Más de la mitad de nuestra plantilla la forman ingenieros de telecomunicaciones, informáticos o industriales y los resultados obtenidos por este equipo humano se traducen en tecnología y productos propios, básicamente en el área del vídeo y control sobre IP.</p>"
                ]}
            />
            <SeparatorLine />

            <IconPanel
                title="Algunas instituciones en las que ya está instalado Séneca"
                iconArray={[
                    {
                        title: "PSA",
                        href: "http://www.vigo.psa-peugeot-citroen.com/",
                        src: "/images/us/featured/psa.png"
                    },
                    {
                        title: "Repsol",
                        href: "http://www.repsol.com/",
                        src: "/images/us/featured/repsol.png"
                    },
                    {
                        title: "CESGA",
                        href: "http://www.cesga.es/",
                        src: "/images/us/featured/cesga.png"
                    },
                    {
                        title: "Parlamento de Galicia",
                        href: "http://www.parlamentodegalicia.es/",
                        src: "/images/us/featured/galicia.png"
                    },
                    {
                        title: "Parlamento de Canarias",
                        href: "http://parcan.es/",
                        src: "/images/us/featured/canarias.png"
                    },
                    {
                        title: "Junta General del Principado de Asturias",
                        href: "http://www.jgpa.es/",
                        src: "/images/us/featured/jgpa.png"
                    },
                    {
                        title: "Cortes de Castilla y León",
                        href: "http://www.ccyl.es/",
                        src: "/images/us/featured/ccyl.png"
                    },
                    {
                        title: "Parlamento de la Rioja",
                        href: "https://www.parlamento-larioja.org/",
                        src: "/images/us/featured/rioja.png"
                    },
                    {
                        title: "Gobierno de Navarra",
                        href: "http://www.navarra.es/",
                        src: "/images/us/featured/navarra.png"
                    },
                    {
                        title: "Junta de Extremadura",
                        href: "https://www.juntaex.es/",
                        src: "/images/us/featured/extremadura.png"
                    },
                    {
                        title: "Moncloa",
                        href: "https://www.lamoncloa.gob.es/",
                        src: "/images/us/featured/ministerio.png"
                    },
                    {
                        title: "Diputación de Granada",
                        href: "http://www.dipgra.es/",
                        src: "/images/us/featured/granada.png"
                    },
                    {
                        title: "Deputación de Pontevedra",
                        href: "http://www.depo.es/",
                        src: "/images/us/featured/pontevedra.png"
                    },
                    {
                        title: "Parlamento de Andalucía",
                        href: "http://www.parlamentodeandalucia.es/",
                        src: "/images/us/featured/andalucia.png"
                    },
                ]}
            />

            <BluePanelSection
                title="Numerosas instituciones respaldan la solidez técnica del sistema."
                textArray={[
                    "<p className='us-middle-section-label'>La satisfacción, que los primeros usuarios han transmitido a sus colegas, ha sido el factor clave para su expansión.</p>"
                ]}
            />
            <SeparatorLine />

            <ImageSectionItem
                imageURL="/images/us/featured/pnavarra.png"
                imagePosition="before"
                layout="column"
                title="Casos de estudio: Parlamento de Navarra"
                textArray={[
                    "<p class='middle-section-label'><strong>El Parlamento de Navarra encargó a Spica la implantación de sus sistemas integrados de Transcripción, Archivo, Consulta y Catalogación Séneca. El software demostró su alta integración con los sistemas digitales Bosch DCN existentes.</strong></p>",
                    "<p class='middle-section-label'><strong>Los contenidos generados en Séneca se integran con otras aplicaciones que se usan en la institución, como la gestión documental, a través de base de datos y acceso a la reproducción de contenidos desde la web corporativa.</strong></p>"
                ]}
            />

            <ImageSectionItem
                imageURL="/images/us/parlamento-navarra.jpg"
                imagePosition="before"
                layout="row"
                title="Sistemas instalados"
                textArray={[
                    "<ul className='middle-section-label ml-50'><li>Sistema de Grabación Séneca 3Ud</li><li>Sistema de Consulta web Séneca (licencia 25 usuarios)</li><li>Sistema de Archivo digital vídeo y audio masivo Séneca V.6</li><li>Sistema de Transcripción (8 puestos) Séneca</li><li>Cabinas de Prensa TV y Radio</li><li>Web video bajo demanda; Consulta interna externa Séneca V.6</li><li>Sistema de monitorización Presidencia (6 monitores)</li><li>Todos los sistemas han sido actualizados a la Versión V.7</li></ul>"
                ]}
                modern="true"
            />
            <SeparatorLine />

            <TextItem
                title="Partners tecnológicos"
                textArray={[
                    "<p className='middle-section-label'>Nuestro departamento de ingeniería trabaja en equipo con las marcas líderes mundiales en informática, vídeo y equipamientos de congresos como son Microsoft, Adobe, Oracle, Bosch, Panasonic, HP, Autonomy o Wowza para conseguir un sistema homogéneo y robusto, que evite duplicidades pero genere redundancias en su uso.</p>",
                    "<p className='middle-section-label'>Gracias a estas alianzas somos capaces de integrar con éxito la última tecnología de forma equilibrada y rentable para nuestros clientes.</p>",
                    "<p className='middle-section-label'>Además contamos con acuerdos de investigación con centros universitarios y de investigación como son: Universidad de Vigo, Gradiant o el Centro de Supercomputación de Galicia.</p>",
                ]}
            />

            <IconPanel
                isOnlyImage
                iconArray={[
                    {
                        title: "Bosch",
                        src: "/images/us/partners/bosch.png"
                    },
                    {
                        title: "Sony",
                        src: "/images/us/partners/sony.png"
                    },
                    {
                        title: "Wowza",
                        src: "/images/us/partners/wowza.png"
                    },
                    {
                        title: "Panasonic",
                        src: "/images/us/partners/panasonic.png"
                    },
                    {
                        title: "Universidad de Vigo",
                        src: "/images/us/partners/uvigo.png"
                    },
                    {
                        title: "Cesga",
                        src: "/images/us/partners/cesga.png"
                    },
                    {
                        title: "Gradiant",
                        src: "/images/us/partners/gradiant.png"
                    },
                ]}
            />

        </main>
    )

}

export default Us